export default __webpack_public_path__ + "7d6257f41a119dd7288d19b80916b727.ttf";